import React from "react";
import styles from "./index.module.scss";
export default class CircularCheckbox extends React.Component {
    render() {
        return (React.createElement("input", { className: `${styles.circularCheckbox} ${this.props.checked ? styles.check : ""}`, type: "checkbox", onChange: this.props.change, checked: this.props.checked }));
    }
}
